import React from "react";
import { FaWhatsapp, FaTelegramPlane } from "react-icons/fa";

const Support = () => {
  return (
    <div className="support__container">
      <h3 className="support__title">Служба поддержки</h3>
      <p className="support__text">Вы можете связаться с нами через WhatsApp или Telegram:</p>
      <div className="support__buttons">
        <a
          href="https://wa.me/996500073733"
          target="_blank"
          rel="noopener noreferrer"
          className="support__button whatsapp"
        >
          <FaWhatsapp size={24} />
          WhatsApp
        </a>
        <a
          href="https://t.me/+Yn4OkYESMvU5Mjky"
          target="_blank"
          rel="noopener noreferrer"
          className="support__button telegram"
        >
          <FaTelegramPlane size={24} />
          Telegram
        </a>
      </div>
    </div>
  );
};

export default Support;
